/**
 * Admin navigation, in one place. The sidebar renders it and the mobile menu reuses it — two
 * copies of a nav array is how a link ends up in one and not the other.
 */
export interface AdminNavItem { label: string; href: string; description: string }

export const ADMIN_NAV: readonly AdminNavItem[] = [
    { label: 'Overview', href: '/', description: 'What happened recently' },
    { label: 'Enquiries', href: '/enquiries', description: 'Messages from the contact form' },
    { label: 'Pages', href: '/pages', description: 'Editable site content' },
    { label: 'People', href: '/users', description: 'Accounts and access' },
    { label: 'Settings', href: '/settings', description: 'Site-wide configuration' },
    { label: 'Operations', href: '/operations', description: 'Alarms, dead letters, uptime, spend and deploys' },
]
